import React from 'react';

import {
  IMapSettings,
  IMapSettingsParams,
} from 'views/components/Video/MapComponent';

import { mapSettings } from 'config/consts';

export interface WithControllerProps {
  handleChangeMapSettings: (settings: IMapSettingsParams) => void;
  mapSettings: IMapSettings;
}

interface IState {
  mapSettings: IMapSettings;
}

export const mapController = <T extends object>(
  ControlledComponent: React.ComponentType<T>
) =>
  class extends React.Component<T & WithControllerProps> {
    state: IState = {
      mapSettings,
    };

    handleChangeMapSettings = (settings: IMapSettingsParams) => {
      this.setState((prev: IState) => ({
        mapSettings: {
          center: settings.center ? settings.center : prev.mapSettings.center,
          zoom: settings.zoom ? settings.zoom : prev.mapSettings.zoom,
          layers: settings.layers ? settings.layers : prev.mapSettings.layers,
          showDrawPanel: settings.showDrawPanel !== undefined
            ? settings.showDrawPanel
            : prev.mapSettings.showDrawPanel,
        },
      }));
    };

    render() {
      const { mapSettings } = this.state;

      return (
        <ControlledComponent
          handleChangeMapSettings={this.handleChangeMapSettings}
          mapSettings={mapSettings}
          {...this.props as T}
        />
      );
    }
  };

export default mapController;
